import { createStore } from 'redux';

const initialValue = {
    firstNumber: "",
    secondNumber: "",
    firstOpuest: false,
    secondOpuest: false,
    comma: false,
    operation: "",
    result: "",
    history: "",
    screenInitial: true,
    screenStop: false,
}

const reducer = (state = initialValue, action) => {
    switch(action.type){
        case "SET_FIRST_NUMBER":
            return { ...state, firstNumber: action.payload }
        case "SET_SECOND_NUMBER":
            return { ...state, secondNumber: action.payload }
        case "SET_FIRST_OPUEST":
            return { ...state, firstOpuest: action.payload }
        case "SET_SECOND_OPUEST":
            return { ...state, secondOpuest: action.payload }
        case "SET_COMMA":
            return { ...state, comma: action.payload }
        case "SET_OPERATION":
            return { ...state, operation: action.payload }
        case "SET_RESULT":
            return { ...state, result: action.payload }
        case "SET_HISTORY":
            return { ...state, history: action.payload }
        case "SET_SCREEN_INITIAL":
            return { ...state, screenInitial: action.payload }
        case "SET_SCREEN_STOP":
            return { ...state, screenStop: action.payload }
        default: 
            return state;
    }
}

const store = createStore(reducer);

export default store;